module.exports = __webpack_public_path__ + "static/media/map_tecture.8ec52a02.png";